require('../../modules/es6.regexp.replace');
module.exports = require('../../modules/_wks-ext').f('replace');



//////////////////
// WEBPACK FOOTER
// ./~/core-js/library/fn/symbol/replace.js
// module id = 2yZo
// module chunks = 3